import cx from 'classnames'

import styles from './cardFooter.module.scss'

export const CardFooter = ({ children, className }: { children: React.ReactNode; className: string }) => {
  return <div className={cx(styles.cardFooter, className)}>{children}</div>
}

CardFooter.displayName = 'CardFooter'
